import {takeLatest, takeEvery} from "redux-saga";
import {fork, put, call, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import {
  showModalWindow,
  removeModalWindow,
  showWindow
  } from "../actions/WindowActions";
import {
  performApiLoadCall,
  performApiCallWithoutReponse
  } from "./helpers";
import * as InventoryApiActions from "../actions/InventoryApiActions";
import * as InventoryApi from "../lib/api/InventoryApi";
import {Map} from "immutable";


function* requestAddStock(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddStockWindow", {warehouseId: baseAction.warehouseId}, "Add Stock"));
  yield take([InventoryApiActions.ADD_STOCK.CANCEL, InventoryApiActions.ADD_STOCK.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddStock() {
  yield takeLatest(InventoryApiActions.REQUEST_ADD_STOCK, requestAddStock);
}

function* requestRemoveStock(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemoveStockWindow", {warehouseId: baseAction.warehouseId}, "Remove Stock"));
  yield take([InventoryApiActions.REMOVE_STOCK.CANCEL, InventoryApiActions.REMOVE_STOCK.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemoveStock() {
  yield takeLatest(InventoryApiActions.REQUEST_REMOVE_STOCK, requestRemoveStock);
}


// Load water pallets.
function* loadWaterPallets(baseAction) {
  yield call(performApiLoadCall, InventoryApi.getWaterPallets, undefined, InventoryApiActions.LOAD_WATER_PALLETS);
}
function* watchLoadWaterPallets() {
  yield takeLatest(InventoryApiActions.LOAD_WATER_PALLETS.LOAD, loadWaterPallets);
}


// Handle GUI for recording water test result.
function* recordWaterTestResultInput(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RecordWaterTestResultWindow", {pallet_id: baseAction.pallet_id}, "Record Water Test Result"));
  yield take([InventoryApiActions.RECORD_WATER_TEST_RESULT.CANCEL, InventoryApiActions.RECORD_WATER_TEST_RESULT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRecordWaterTestResultInput() {
  yield takeLatest(InventoryApiActions.REQUEST_RECORD_WATER_TEST_RESULT_INPUT, recordWaterTestResultInput);
}


// Record water test result.
function* submitWaterTestResult(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.recordWaterTestResult, baseAction.data, InventoryApiActions.RECORD_WATER_TEST_RESULT);
}
function* watchRecordWaterTestResult() {
  yield takeEvery(InventoryApiActions.RECORD_WATER_TEST_RESULT.SUBMIT, submitWaterTestResult);
}


// Handle GUI for changing location availability.
function* requestChangeAvailabilityForLocation(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeAvailabilityForLocationWindow", {shopId: baseAction.shopId, kind: baseAction.kind, code: baseAction.code, name: baseAction.name}, baseAction.name));
  yield take([InventoryApiActions.CHANGE_AVAILABILITY_FOR_LOCATION.CANCEL, InventoryApiActions.CHANGE_AVAILABILITY_FOR_LOCATION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeAvailabilityForLocation() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_AVAILABILITY_FOR_LOCATION, requestChangeAvailabilityForLocation);
}

// Handle GUI for setting operation hours for a warehouse.
function* requestSetOperationHours(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetOperationHoursWindow", {id: baseAction.id}, `Set operation hours for ${baseAction.id}`));
  yield take([InventoryApiActions.SET_OPERATION_HOURS.CANCEL, InventoryApiActions.SET_OPERATION_HOURS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSetOperationHours() {
  yield takeLatest(InventoryApiActions.REQUEST_SET_OPERATION_HOURS, requestSetOperationHours);
}

// Handle GUI for setting a warehouse backup.
function* requestAssignWarehouseBackup(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AssignWarehouseBackupWindow", {id: baseAction.id}, `Assign backup for ${baseAction.id}`));
  yield take([InventoryApiActions.ASSIGN_WAREHOUSE_BACKUP.CANCEL, InventoryApiActions.ASSIGN_WAREHOUSE_BACKUP.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAssignWarehouseBackup() {
  yield takeLatest(InventoryApiActions.REQUEST_ASSIGN_WAREHOUSE_BACKUP, requestAssignWarehouseBackup);
}

// Handle GUI for scanning a barcode and associating it with the tracking number.
function* requestScanBarcode(baseAction) {
  let windowId = generateUUID();
  console.log("saga", baseAction)
  yield put(showModalWindow(windowId, "ScanBarcodeWindow", {warehouseId: baseAction.warehouseId, packageId: baseAction.packageId}, "Barcode Scan Verification", Map({ cancelType: InventoryApiActions.SCAN_BARCODE.CANCEL })));
  yield take([InventoryApiActions.SCAN_BARCODE.CANCEL, InventoryApiActions.SCAN_BARCODE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestScanBarcode() {
  yield takeLatest(InventoryApiActions.REQUEST_SCAN_BARCODE, requestScanBarcode);
}
// Handle GUI for displaying an order along with its packages and statuses.
function* requestOrderDetail(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "OrderDetailWindow", {warehouseId: baseAction.warehouseId, jobId: baseAction.jobId}, "Order Detail"));
  yield take([InventoryApiActions.ORDER_DETAIL.CANCEL, InventoryApiActions.ORDER_DETAIL.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestOrderDetail() {
  yield takeLatest(InventoryApiActions.REQUEST_ORDER_DETAIL, requestOrderDetail);
}


// Handle GUI for creating a product.
function* requestCreateProduct(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreateProductWindow", {productType: baseAction.productType}, "Create product"));
  yield take([InventoryApiActions.CREATE_PRODUCT.CANCEL, InventoryApiActions.CREATE_PRODUCT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreateProduct() {
  yield takeLatest(InventoryApiActions.REQUEST_CREATE_PRODUCT, requestCreateProduct);
}

// Handle GUI for creating a product bundle.
function* requestCreateProductBundle(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreateProductBundleWindow", {}, "Create product bundle"));
  yield take([InventoryApiActions.CREATE_PRODUCT_BUNDLE.CANCEL, InventoryApiActions.CREATE_PRODUCT_BUNDLE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreateProductBundle() {
  yield takeLatest(InventoryApiActions.REQUEST_CREATE_PRODUCT_BUNDLE, requestCreateProductBundle);
}

// Handle GUI for adding product variation.
function* requestAddProductVariation(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddProductVariationWindow", {code: baseAction.code}, `Add Variation to ${baseAction.code}`));
  yield take([InventoryApiActions.ADD_PRODUCT_VARIATION.CANCEL, InventoryApiActions.ADD_PRODUCT_VARIATION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddProductVariation() {
  yield takeLatest(InventoryApiActions.REQUEST_ADD_PRODUCT_VARIATION, requestAddProductVariation);
}

// Handle GUI for adding product variation.
function* requestAddProductSize(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddProductSizeWindow", {code: baseAction.code}, `Add Size to ${baseAction.code}`));
  yield take([InventoryApiActions.ADD_PRODUCT_SIZE.CANCEL, InventoryApiActions.ADD_PRODUCT_SIZE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddProductSize() {
  yield takeLatest(InventoryApiActions.REQUEST_ADD_PRODUCT_SIZE, requestAddProductSize);
}


// Handle GUI for creating a new product configuration.
function* requestCreateProductConfiguration(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreateProductConfigurationWindow", {code: baseAction.code}, `Create Configuration for ${baseAction.code}`));
  yield take([InventoryApiActions.CREATE_PRODUCT_CONFIGURATION.CANCEL, InventoryApiActions.CREATE_PRODUCT_CONFIGURATION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreateProductConfiguration() {
  yield takeLatest(InventoryApiActions.REQUEST_CREATE_PRODUCT_CONFIGURATION, requestCreateProductConfiguration);
}

// Handle GUI for changing product description.
function* requestChangeProductDescription(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeProductDescriptionWindow", {sku: baseAction.sku}, `Change description for ${baseAction.sku}`));
  yield take([InventoryApiActions.CHANGE_PRODUCT_DESCRIPTION.CANCEL, InventoryApiActions.CHANGE_PRODUCT_DESCRIPTION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeProductDescription() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_PRODUCT_DESCRIPTION, requestChangeProductDescription);
}

// Handle GUI for changing product bundle description.
function* requestChangeProductBundleDescription(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeProductBundleDescriptionWindow", {sku: baseAction.sku}, `Change description for ${baseAction.sku}`));
  yield take([InventoryApiActions.CHANGE_PRODUCT_BUNDLE_DESCRIPTION.CANCEL, InventoryApiActions.CHANGE_PRODUCT_BUNDLE_DESCRIPTION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeProductBundleDescription() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_PRODUCT_BUNDLE_DESCRIPTION, requestChangeProductBundleDescription);
}

// Handle GUI for changing product measurements.
function* requestChangeProductMeasurements(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeProductMeasurementsWindow", {sku: baseAction.sku}, `Change measurements for ${baseAction.sku}`));
  yield take([InventoryApiActions.CHANGE_PRODUCT_MEASUREMENTS.CANCEL, InventoryApiActions.CHANGE_PRODUCT_MEASUREMENTS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeProductMeasurements() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_PRODUCT_MEASUREMENTS, requestChangeProductMeasurements);
}


// Handle GUI for adding products to shop.
function* requestAddProductToShop(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddProductToShopWindow", {shopId: baseAction.shopId, shopTitle: baseAction.shopTitle}, `Add product to shop ${baseAction.shopTitle}`));
  yield take([InventoryApiActions.ADD_PRODUCT_TO_SHOP.CANCEL, InventoryApiActions.ADD_PRODUCT_TO_SHOP.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddProductToShop() {
  yield takeLatest(InventoryApiActions.REQUEST_ADD_PRODUCT_TO_SHOP, requestAddProductToShop);
}

// Handle GUI for removing a product from a shop.
function* requestRemoveProductFromShop(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemoveProductFromShopWindow", {shopId: baseAction.shopId, productId: baseAction.productId}, `Remove product from shop ${baseAction.shopId}`));
  yield take([InventoryApiActions.REMOVE_PRODUCT_FROM_SHOP.CANCEL, InventoryApiActions.REMOVE_PRODUCT_FROM_SHOP.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemoveProductFromShop() {
  yield takeLatest(InventoryApiActions.REQUEST_REMOVE_PRODUCT_FROM_SHOP, requestRemoveProductFromShop);
}

// Handle GUI for changing a products price.
function* requestChangeProductPricing(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeProductPricingWindow", {shopId: baseAction.shopId, productId: baseAction.productId}, `Change pricing for ${baseAction.productId}`));
  yield take([InventoryApiActions.CHANGE_PRODUCT_PRICING.CANCEL, InventoryApiActions.CHANGE_PRODUCT_PRICING.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeProductPricing() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_PRODUCT_PRICING, requestChangeProductPricing);
}

// Handle GUI for changing a products price.
function* requestChangeSubscriptionProductPricing(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeSubscriptionProductPricingWindow", {shopId: baseAction.shopId, productId: baseAction.productId}, `Change pricing for ${baseAction.productId}`));
  yield take([InventoryApiActions.CHANGE_SUBSCRIPTION_PRODUCT_PRICING.CANCEL, InventoryApiActions.CHANGE_SUBSCRIPTION_PRODUCT_PRICING.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeSubscriptionProductPricing() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_SUBSCRIPTION_PRODUCT_PRICING, requestChangeSubscriptionProductPricing);
}

// Handle GUI for changing a product pricelist for a shop.
function* requestCommitProductPricelist(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CommitProductPricelistWindow", {shopId: baseAction.shopId}, "Commit product pricelist"));
  yield take([InventoryApiActions.COMMIT_PRODUCT_PRICELIST.CANCEL, InventoryApiActions.COMMIT_PRODUCT_PRICELIST.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCommitProductPricelist() {
  yield takeLatest(InventoryApiActions.REQUEST_COMMIT_PRODUCT_PRICELIST, requestCommitProductPricelist);
}

// Handle GUI for changing a subscription pricelist for a shop.
function* requestCommitSubscriptionPricelist(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CommitSubscriptionPricelistWindow", {shopId: baseAction.shopId}, "Commit subscription pricelist"));
  yield take([InventoryApiActions.COMMIT_SUBSCRIPTION_PRICELIST.CANCEL, InventoryApiActions.COMMIT_SUBSCRIPTION_PRICELIST.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCommitSubscriptionPricelist() {
  yield takeLatest(InventoryApiActions.REQUEST_COMMIT_SUBSCRIPTION_PRICELIST, requestCommitSubscriptionPricelist);
}

// Handle GUI for applying a products surcharge.
function* requestApplyProductSurcharge(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ApplyProductSurchargeWindow", {shopId: baseAction.shopId, productId: baseAction.productId}, `Apply surcharge for ${baseAction.productId}`));
  yield take([InventoryApiActions.APPLY_PRODUCT_SURCHARGE.CANCEL, InventoryApiActions.APPLY_PRODUCT_SURCHARGE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestApplyProductSurcharge() {
  yield takeLatest(InventoryApiActions.REQUEST_APPLY_PRODUCT_SURCHARGE, requestApplyProductSurcharge);
}

// Handle GUI for editing a products surcharge.
function* requestEditProductSurcharge(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditProductSurchargeWindow", {shopId: baseAction.shopId, productId: baseAction.productId, countryCode: baseAction.countryCode, stateCode: baseAction.stateCode}, `Edit surcharge for ${baseAction.productId}`));
  yield take([InventoryApiActions.EDIT_PRODUCT_SURCHARGE.CANCEL, InventoryApiActions.EDIT_PRODUCT_SURCHARGE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditProductSurcharge() {
  yield takeLatest(InventoryApiActions.REQUEST_EDIT_PRODUCT_SURCHARGE, requestEditProductSurcharge);
}



// Handle GUI for adding products to bundle.
function* requestAddProductToBundle(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddProductToBundleWindow", {sku: baseAction.sku}, `Add products to bundle ${baseAction.sku}`));
  yield take([InventoryApiActions.ADD_PRODUCT_TO_BUNDLE.CANCEL, InventoryApiActions.ADD_PRODUCT_TO_BUNDLE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddProductToBundle() {
  yield takeLatest(InventoryApiActions.REQUEST_ADD_PRODUCT_TO_BUNDLE, requestAddProductToBundle);
}

// Handle GUI for removing products from bundle.
function* requestRemoveProductFromBundle(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemoveProductFromBundleWindow", {sku: baseAction.sku}, `Remove products from bundle ${baseAction.sku}`));
  yield take([InventoryApiActions.REMOVE_PRODUCT_FROM_BUNDLE.CANCEL, InventoryApiActions.REMOVE_PRODUCT_FROM_BUNDLE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemoveProductFromBundle() {
  yield takeLatest(InventoryApiActions.REQUEST_REMOVE_PRODUCT_FROM_BUNDLE, requestRemoveProductFromBundle);
}

// Change product description.
function* changeProductDescription(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.changeProductDescription, baseAction.data, InventoryApiActions.CHANGE_PRODUCT_DESCRIPTION);
}
function* watchChangeProductDescription() {
  yield takeEvery(InventoryApiActions.CHANGE_PRODUCT_DESCRIPTION.SUBMIT, changeProductDescription);
}


// Handle GUI for adding product to inventory.
function* requestAddProductToInventory(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddProductToInventoryWindow", {code: baseAction.code, sku: baseAction.sku}, `Add Inventory ${baseAction.sku}`));
  yield take([InventoryApiActions.ADD_PRODUCT_TO_INVENTORY.CANCEL, InventoryApiActions.ADD_PRODUCT_TO_INVENTORY.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddProductToInventory() {
  yield takeLatest(InventoryApiActions.REQUEST_ADD_PRODUCT_TO_INVENTORY, requestAddProductToInventory);
}

// Change product description.
function* addProductToInventory(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.addProductToInventory, baseAction.data, InventoryApiActions.ADD_PRODUCT_TO_INVENTORY);
}
function* watchAddProductToInventory() {
  yield takeEvery(InventoryApiActions.ADD_PRODUCT_TO_INVENTORY.SUBMIT, addProductToInventory);
}


// Handle GUI for rejecting a water container..
function* requestRejectWaterContainer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RejectWaterContainerWindow", {serial: baseAction.serial, palletId: baseAction.palletId}, `Decommission bottle ${baseAction.serial}`));
  yield take([InventoryApiActions.REJECT_WATER_CONTAINER.CANCEL, InventoryApiActions.REJECT_WATER_CONTAINER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRejectWaterContainer() {
  yield takeLatest(InventoryApiActions.REQUEST_REJECT_WATER_CONTAINER, requestRejectWaterContainer);
}

// Handle GUI for adding water container to pallet.
function* requestAddWaterContainerToPallet(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddWaterContainerToPalletWindow", {palletId: baseAction.palletId}, `Add bottle to pallet ${baseAction.palletId}`));
  yield take([InventoryApiActions.ADD_WATER_CONTAINER_TO_PALLET.CANCEL, InventoryApiActions.ADD_WATER_CONTAINER_TO_PALLET.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddWaterContainerToPallet() {
  yield takeLatest(InventoryApiActions.REQUEST_ADD_WATER_CONTAINER_TO_PALLET, requestAddWaterContainerToPallet);
}




// Handle GUI for removing a product.
function* requestRemoveProduct(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemoveProductWindow", {code: baseAction.code}, `Remove product ${baseAction.code}`));
  yield take([InventoryApiActions.REMOVE_PRODUCT.CANCEL, InventoryApiActions.REMOVE_PRODUCT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemoveProduct() {
  yield takeLatest(InventoryApiActions.REQUEST_REMOVE_PRODUCT, requestRemoveProduct);
}

// Creates a new product.
function* createProduct(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.createProduct, baseAction.data, InventoryApiActions.CREATE_PRODUCT, baseAction.formName);
}
function* watchCreateProduct() {
  yield takeEvery(InventoryApiActions.CREATE_PRODUCT.SUBMIT, createProduct);
}

// Add a variation to a product.
function* addProductVariation(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.addProductVariation, baseAction.data, InventoryApiActions.ADD_PRODUCT_VARIATION);
}
function* watchAddProductVariation() {
  yield takeEvery(InventoryApiActions.ADD_PRODUCT_VARIATION.SUBMIT, addProductVariation);
}


// Add a size to a product.
function* addProductSize(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.addProductSize, baseAction.data, InventoryApiActions.ADD_PRODUCT_SIZE);
}
function* watchAddProductSize() {
  yield takeEvery(InventoryApiActions.ADD_PRODUCT_SIZE.SUBMIT, addProductSize);
}

// Create a new product configuration.
function* createProductConfiguration(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.createProductConfiguration, baseAction.data, InventoryApiActions.CREATE_PRODUCT_CONFIGURATION);
}
function* watchCreateProductConfiguration() {
  yield takeEvery(InventoryApiActions.CREATE_PRODUCT_CONFIGURATION.SUBMIT, createProductConfiguration);
}

// Load products.
function* loadProducts(baseAction) {
  yield call(performApiLoadCall, InventoryApi.getProducts, undefined, InventoryApiActions.LOAD_PRODUCTS);
}
function* watchLoadProducts() {
  yield takeLatest(InventoryApiActions.LOAD_PRODUCTS.LOAD, loadProducts);
}

// Load product.
function* loadProduct(baseAction) {
  yield call(performApiLoadCall, InventoryApi.getProduct, baseAction.code, InventoryApiActions.LOAD_PRODUCT);
}
function* watchLoadProduct() {
  yield takeLatest(InventoryApiActions.LOAD_PRODUCT.LOAD, loadProduct);
}

// Load stock items.
function* loadStockItems(baseAction) {
  yield call(performApiLoadCall, InventoryApi.getStockItems, undefined, InventoryApiActions.LOAD_STOCK_ITEMS);
}
function* watchLoadStockItems() {
  yield takeLatest(InventoryApiActions.LOAD_STOCK_ITEMS.LOAD, loadStockItems);
}

// Load stock item.
function* loadStockItem(baseAction) {
  yield call(performApiLoadCall, InventoryApi.getStockItem, baseAction.code, InventoryApiActions.LOAD_STOCK_ITEM);
}
function* watchLoadStockItem() {
  yield takeLatest(InventoryApiActions.LOAD_STOCK_ITEM.LOAD, loadStockItem);
}




// Handle GUI for renaming warehouses.
function* requestRenameWarehouse(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RenameWarehouseWindow", {id: baseAction.id}, "Rename warehouse"));
  yield take([InventoryApiActions.RENAME_WAREHOUSE.CANCEL, InventoryApiActions.RENAME_WAREHOUSE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRenameWarehouse() {
  yield takeLatest(InventoryApiActions.REQUEST_RENAME_WAREHOUSE, requestRenameWarehouse);
}


// Handle GUI for changing warehouse address.
function* requestChangeWarehouseAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeWarehouseAddressWindow", {id: baseAction.id}, "Warehouse address"));
  yield take([InventoryApiActions.CHANGE_WAREHOUSE_ADDRESS.CANCEL, InventoryApiActions.CHANGE_WAREHOUSE_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeWarehouseAddress() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_WAREHOUSE_ADDRESS, requestChangeWarehouseAddress);
}

// Handle GUI for changing warehouse contact info.
function* requestChangeWarehouseContact(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeWarehouseContactWindow", {id: baseAction.id}, "Warehouse contact"));
  yield take([InventoryApiActions.CHANGE_WAREHOUSE_CONTACT.CANCEL, InventoryApiActions.CHANGE_WAREHOUSE_CONTACT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeWarehouseContact() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_WAREHOUSE_CONTACT, requestChangeWarehouseContact);
}


// Handle GUI for registering warehouse.
function* requestRegisterWarehouse(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RegisterWarehouseWindow", undefined, "Register warehouse"));
  yield take([InventoryApiActions.REGISTER_WAREHOUSE.CANCEL, InventoryApiActions.REGISTER_WAREHOUSE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRegisterWarehouse() {
  yield takeLatest(InventoryApiActions.REQUEST_REGISTER_WAREHOUSE, requestRegisterWarehouse);
}

// Handle GUI for registering pallet.
function* requestRegisterPallet(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RegisterOtherPalletWindow", undefined, "Register non-water pallet"));
  yield take([InventoryApiActions.REGISTER_OTHER_PALLET.CANCEL, InventoryApiActions.REGISTER_OTHER_PALLET.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRegisterPallet() {
  yield takeLatest(InventoryApiActions.REQUEST_REGISTER_OTHER_PALLET, requestRegisterPallet);
}

// Handle GUI for modifying pallet.
function* requestModifyPallet(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ModifyOtherPalletWindow", {palletId: baseAction.palletId}, `Modify pallet ${baseAction.palletId}`));
  yield take([InventoryApiActions.MODIFY_OTHER_PALLET.CANCEL, InventoryApiActions.MODIFY_OTHER_PALLET.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestModifyPallet() {
  yield takeLatest(InventoryApiActions.REQUEST_MODIFY_OTHER_PALLET, requestModifyPallet);
}

// Handle GUI for changing us tax setting.
function* requestChangeUsTaxSetting(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeUsTaxSettingWindow", {stateCode: baseAction.stateCode}, `Change setting for ${baseAction.name}`));
  yield take([InventoryApiActions.CHANGE_US_TAX_SETTING.CANCEL, InventoryApiActions.CHANGE_US_TAX_SETTING.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeUsTaxSetting() {
  yield takeLatest(InventoryApiActions.REQUEST_CHANGE_US_TAX_SETTING, requestChangeUsTaxSetting);
}





// Rename Warehouse.
function* renameWarehouse(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.renameWarehouse, baseAction.data, InventoryApiActions.RENAME_WAREHOUSE);
}
function* watchRenameWarehouse() {
  yield takeEvery(InventoryApiActions.RENAME_WAREHOUSE.SUBMIT, renameWarehouse);
}

// Change Warehouse contact.
function* changeWarehouseContact(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.changeWarehouseContact, baseAction.data, InventoryApiActions.CHANGE_WAREHOUSE_CONTACT);
}
function* watchChangeWarehouseContact() {
  yield takeEvery(InventoryApiActions.CHANGE_WAREHOUSE_CONTACT.SUBMIT, changeWarehouseContact);
}

// Change Warehouse contact.
function* changeWarehouseAddress(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.changeWarehouseAddress, baseAction.data, InventoryApiActions.CHANGE_WAREHOUSE_ADDRESS);
}
function* watchChangeWarehouseAddress() {
  yield takeEvery(InventoryApiActions.CHANGE_WAREHOUSE_ADDRESS.SUBMIT, changeWarehouseAddress);
}


// Register a new Warehouse.
function* registerWarehouse(baseAction) {
  yield call(performApiCallWithoutReponse, InventoryApi.registerWarehouse, baseAction.data, InventoryApiActions.REGISTER_WAREHOUSE, baseAction.formName);
}
function* watchRegisterWarehouse() {
  yield takeEvery(InventoryApiActions.REGISTER_WAREHOUSE.SUBMIT, registerWarehouse);
}


// Load warehouses.
function* loadWarehouses(baseAction) {
  yield call(performApiLoadCall, InventoryApi.getWarehouses, undefined, InventoryApiActions.LOAD_WAREHOUSES);
}
function* watchLoadWarehouses() {
  yield takeLatest(InventoryApiActions.LOAD_WAREHOUSES.LOAD, loadWarehouses);
}

// Load warehouse.
function* loadWarehouse(baseAction) {
  yield call(performApiLoadCall, InventoryApi.getWarehouse, baseAction.id, InventoryApiActions.LOAD_WAREHOUSE);
}
function* watchLoadWarehouse() {
  yield takeLatest(InventoryApiActions.LOAD_WAREHOUSE.LOAD, loadWarehouse);
}



export default function* saga() {
  yield fork(watchLoadWaterPallets);
  yield fork(watchRecordWaterTestResultInput);
  yield fork(watchRecordWaterTestResult);
  yield fork(watchLoadWarehouses);
  yield fork(watchLoadWarehouse);
  yield fork(watchRequestRenameWarehouse);
  yield fork(watchRequestRegisterWarehouse);  
  yield fork(watchRenameWarehouse);
  yield fork(watchRegisterWarehouse);
  yield fork(watchRequestChangeWarehouseAddress);
  yield fork(watchRequestChangeWarehouseContact);
  yield fork(watchChangeWarehouseContact);
  yield fork(watchChangeWarehouseAddress);

  yield fork(watchLoadProduct);
  yield fork(watchLoadProducts);
  yield fork(watchLoadStockItems);
  yield fork(watchLoadStockItem);
  
  yield fork(watchRequestCreateProduct);
  yield fork(watchCreateProduct);

  yield fork(watchRequestCreateProductBundle);

  yield fork(watchRequestAddProductVariation);
  yield fork(watchRequestAddProductSize);
  yield fork(watchRequestCreateProductConfiguration);
  yield fork(watchRequestChangeProductDescription);
  yield fork(watchRequestChangeProductBundleDescription);
  yield fork(watchRequestChangeProductMeasurements);

  yield fork(watchRequestAddProductToBundle);
  yield fork(watchRequestRemoveProductFromBundle);

  yield fork(watchRequestAddProductToShop);
  yield fork(watchRequestRemoveProductFromShop);
  yield fork(watchRequestChangeProductPricing);
  yield fork(watchRequestChangeSubscriptionProductPricing);
  yield fork(watchRequestCommitProductPricelist);
  yield fork(watchRequestCommitSubscriptionPricelist);
  yield fork(watchRequestApplyProductSurcharge);
  yield fork(watchRequestEditProductSurcharge);

  yield fork(watchRequestRemoveProduct);
  yield fork(watchAddProductVariation);
  yield fork(watchAddProductSize);
  yield fork(watchCreateProductConfiguration);
  yield fork(watchChangeProductDescription);
  yield fork(watchRequestAddProductToInventory);
  yield fork(watchAddProductToInventory);

  yield fork(watchRequestAddStock);
  yield fork(watchRequestRemoveStock);

  yield fork(watchRequestRejectWaterContainer);
  yield fork(watchRequestAddWaterContainerToPallet);
  yield fork(watchRequestChangeAvailabilityForLocation);

  yield fork(watchRequestChangeUsTaxSetting);
  yield fork(watchRequestSetOperationHours);
  yield fork(watchRequestAssignWarehouseBackup);
  yield fork(watchRequestScanBarcode);
  yield fork(watchRequestOrderDetail);

  yield fork(watchRequestRegisterPallet);
  yield fork(watchRequestModifyPallet);
}
